import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { MESSAGE_TYPE } from '@xcf-libs/toast/toast.enum';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    private snackBar = inject(MatSnackBar);

    /**
     * Opens a success toast notification.
     * @param message The message to display.
     * @param duration Optional duration in milliseconds. Defaults to 3000.
     */
    success(message: string, duration = 3000): void {
        this.showToast(message, MESSAGE_TYPE.SUCCESS, duration);
    }

    /**
     * Opens an error toast notification.
     * @param message The message to display.
     * @param duration Optional duration in milliseconds. Defaults to 5000.
     */
    error(message: string, duration = 5000): void {
        this.showToast(message, MESSAGE_TYPE.ERROR, duration);
    }

    /**
     * Opens an info toast notification.
     * @param message The message to display.
     * @param duration Optional duration in milliseconds. Defaults to 3000.
     */
    info(message: string, duration = 3000): void {
        this.showToast(message, MESSAGE_TYPE.INFO, duration);
    }

    /**
     * Opens a warning toast notification.
     * @param message The message to display.
     * @param duration Optional duration in milliseconds. Defaults to 4000.
     */
    warn(message: string, duration = 4000): void {
        this.showToast(message, MESSAGE_TYPE.WARNING, duration);
    }

    // --- Private Method to Show Toast ---
    private showToast(message: string, type: MESSAGE_TYPE, duration: number): void {
        this.snackBar.open(message, 'Close', {
            duration: duration,
            panelClass: [type || MESSAGE_TYPE.DEFAULT],
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
        });
    }
}
